(function () {
    var POPUP_SELECTOR = '.glFilter-search-popup';
    var TRIGGER_SELECTOR = '#quick-search';
    var FORM_TRIGGER_SELECTOR = '.searchform';
    var CUSTOM_ID = 'my-custom-comp';
  
    function createMount() {
      var wrap = document.createElement('div');
      wrap.id = CUSTOM_ID;
      wrap.className = 'my-widget-container';
      var tpl = document.getElementById('my-comp-tpl');
      wrap.innerHTML = tpl ? tpl.innerHTML : '<div class="my-widget">组件加载失败</div>';
      return wrap;
    }
    function injectIntoPopup(popupRoot) {
      if (!popupRoot || popupRoot.querySelector('#' + CUSTOM_ID)) return;
      var target =  popupRoot.querySelector('.gl-fullscreen-layer');
      if (!target) return;
      var mount = createMount();
      target.appendChild(mount);
      bindInputCancel(popupRoot);
    }
  
    function tryInject() {
      var popup = document.querySelector(POPUP_SELECTOR);
      if (popup) injectIntoPopup(popup);
    }
  
    function onDomReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }
  
    function bindInputCancel(popupRoot) {
      if (!popupRoot) return;
      var input = popupRoot.querySelector('.gl-d-searchbox-input');
      if (!input || input.dataset._customInjectBound === '1') return;
      input.dataset._customInjectBound = '1';
      input.addEventListener('input', function () {
        var value = (input.value || '').trim();
        var injected = document.getElementById(CUSTOM_ID);
        if (value.length > 0) {
          // 有输入内容：移除自定义模块
          if (injected) injected.remove();
        } else {
          // 输入被清空：确保再次注入
          var popup = popupRoot || document.querySelector(POPUP_SELECTOR);
          if (popup && !injected) {
            injectIntoPopup(popup);
          }
        }
      });
    }
  
    onDomReady(function () {
      // 初次尝试（若弹窗已在 DOM 中）
      tryInject();
      // 如果弹窗已有输入框，则绑定监听（即使未注入模板，也先绑定，后续输入仍可清理）
      var existingPopup = document.querySelector(POPUP_SELECTOR);
      if (existingPopup) bindInputCancel(existingPopup);
  
      // 监听第三方动态插入弹窗
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (
              n && n.nodeType === 1 &&
              (n.matches && n.matches(POPUP_SELECTOR) || (n.querySelector && n.querySelector(POPUP_SELECTOR)))
            ) {
              tryInject();
              // 绑定输入监听
              var popupNow = document.querySelector(POPUP_SELECTOR);
              if (popupNow) bindInputCancel(popupNow);
              return;
            }
          }
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
  
      // 点击触发按钮后兜底尝试（第三方通常在这时创建弹窗）
      document.addEventListener('click', function (e) {
        var isQuickSearch = e.target && (e.target.closest ? e.target.closest(TRIGGER_SELECTOR) : null);
        var isSearchForm = e.target && (e.target.closest ? e.target.closest(FORM_TRIGGER_SELECTOR) : null);
        if (isQuickSearch || isSearchForm) {
          setTimeout(tryInject, 0);
          setTimeout(tryInject, 200);
          setTimeout(tryInject, 600);
        }
      });
    });
  })();
  
  (function () {
    function onDomReady(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
      } else {
        fn();
      }
    }
  
    function isProductPage() {
      return document.body && document.body.classList.contains('template-product');
    }
  
    function findGiftSpecialElement() {
      return document.querySelector('.gift-special');
    }
  
  function decodeHtmlEntities(value) {
    if (value == null) return '';
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(value);
    return textarea.value;
  }

  function extractGiftTitleFromValue(rawValue) {
    if (!rawValue) return '';
    var decoded = decodeHtmlEntities(rawValue);
    return decoded.replace(/\s*\[\s*\$?[\d.,]+\s*\]\s*$/, '').trim();
  }

  function extractGiftDetailFromValue(rawValue) {
    if (!rawValue) return '';
    var decoded = decodeHtmlEntities(rawValue);
    var container = document.createElement('div');
    container.innerHTML = decoded;
    var detailDiv = container.querySelector('div');
    return detailDiv ? detailDiv.innerHTML.trim() : '';
  }

  function getGiftTitleFromOption(optionEl) {
    if (!optionEl) return '';
    var rawValue =
      optionEl.getAttribute('data-conditional-value') ||
      optionEl.getAttribute('value');
    if (!rawValue) {
      var label = optionEl.closest('label');
      rawValue = label ? label.getAttribute('aria-label') : '';
    }
    if (!rawValue) {
      var input = optionEl.querySelector('input');
      rawValue = input ? input.value : '';
    }
    return extractGiftTitleFromValue(rawValue);
  }

  function getGiftDetailFromOption(optionEl) {
    if (!optionEl) return '';
    var rawValue =
      optionEl.getAttribute('data-conditional-value') ||
      optionEl.getAttribute('value');
    if (!rawValue) {
      var label = optionEl.closest('label');
      rawValue = label ? label.getAttribute('aria-label') : '';
    }
    if (!rawValue) {
      var input = optionEl.querySelector('input');
      rawValue = input ? input.value : '';
    }
    return extractGiftDetailFromValue(rawValue);
  }

  function removeGiftTooltipInner(optionEl) {
    if (!optionEl) return;
    var label = optionEl.closest('label');
    if (!label) return;
    var tooltipInner = label.querySelector('.hulkapps-tooltip-inner');
    if (tooltipInner && tooltipInner.parentNode) {
      tooltipInner.parentNode.removeChild(tooltipInner);
    }
  }

  function ensureGiftTitle(optionEl) {
    if (!optionEl || optionEl.dataset.giftTitleBound === '1') return;
    var label = optionEl.closest('label');
    if (!label) return;
    removeGiftTooltipInner(optionEl);
    var titleText = getGiftTitleFromOption(optionEl);
    if (!titleText) return;

    var existing = label.querySelector('.gift-special-swatch-title');
    if (existing) {
      existing.textContent = titleText;
      optionEl.dataset.giftTitleBound = '1';
      return;
    }

    var titleEl = document.createElement('div');
    titleEl.className = 'gift-special-swatch-title';
    titleEl.textContent = titleText;
    titleEl.style.cssText = 'display:none;margin-top:6px;text-align:center;font-size:12px;line-height:1.3;';

    var container = optionEl.parentNode && optionEl.parentNode.nodeType === 1 ? optionEl.parentNode : label;
    if (container) {
      if (optionEl.nextSibling && optionEl.nextSibling.parentNode === container) {
        container.insertBefore(titleEl, optionEl.nextSibling);
      } else {
        container.appendChild(titleEl);
      }
    } else {
      label.appendChild(titleEl);
    }

    optionEl.dataset.giftTitleBound = '1';
  }

  function ensureGiftDetailContainer(root) {
    if (!root) return null;
    var detailEl = root.querySelector('.gift-special-selected-detail');
    if (!detailEl) {
      detailEl = document.createElement('div');
      detailEl.className = 'gift-special-selected-detail';
      root.appendChild(detailEl);
    }
    return detailEl;
  }

  function getGiftSpecialCheckboxInput(root) {
    if (!root) return null;
    return root.querySelector('.hulk_po_checkbox input.hulk_po_swatch_multiple_checkbox');
  }

  function getGiftSpecialSwatch(root) {
    if (!root) return null;
    return root.querySelector('.hulk_po_checkbox');
  }

  function isGiftSpecialSelected(root) {
    if (!root) return false;
    var input = getGiftSpecialCheckboxInput(root);
    if (input && input.checked) return true;
    var swatch = getGiftSpecialSwatch(root);
    if (swatch && swatch.classList && swatch.classList.contains('swatch_selected')) return true;
    if (root.querySelector('.hulkapps_mswatch_option.swatch_selected')) return true;
    if (root.querySelector('.hulkapps_option_child.swatch_selected')) return true;
    return false;
  }

  function removeGiftSelectionRow(root) {
    if (!root) return;
    var rowEl = root.querySelector('.gift-special-select-row');
    if (rowEl && rowEl.parentNode) {
      rowEl.parentNode.removeChild(rowEl);
    }
  }

  function getGiftSpecialBaseTitle(root) {
    if (!root) return 'Free Cleaning Kit';
    var swatch = getGiftSpecialSwatch(root);
    var title = getGiftTitleFromOption(swatch);
    if (title) return title;

    var titleEl = root.querySelector('.hulkapps_option_name');
    var fallback = titleEl ? titleEl.textContent : '';
    fallback = (fallback || '')
      .replace(/Worth\s*\$?[\d.,]+/gi, '')
      .replace(/\(Select if Needed\)/gi, '')
      .replace(/\bSelected\b/gi, '')
      .replace(/^Select\s+/i, '')
      .trim();

    return fallback || 'Free Cleaning Kit';
  }

  function ensureGiftSpecialTitleBadge(root) {
    if (!root) return;
    var titleEl = root.querySelector('.hulkapps_option_name');
    if (!titleEl) return;

    titleEl.classList.add('gift-special-card-header');
    titleEl.removeAttribute('tabindex');

    var titleTextEl = titleEl.querySelector('.gift-special-title-main') || titleEl.querySelector('div');
    if (!titleTextEl) {
      titleTextEl = document.createElement('div');
      titleEl.insertBefore(titleTextEl, titleEl.firstChild);
    }

    var needsRebuild =
      !titleTextEl.classList.contains('gift-special-title-main') ||
      !titleTextEl.querySelector('.gift-special-selection-indicator') ||
      !titleTextEl.querySelector('.gift-special-title-text') ||
      !!titleTextEl.querySelector('.gift-special-title-icon');

    titleTextEl.classList.add('gift-special-title-main');

    if (needsRebuild) {
      titleTextEl.textContent = '';

      var indicatorEl = document.createElement('span');
      indicatorEl.className = 'gift-special-selection-indicator';
      indicatorEl.setAttribute('aria-hidden', 'true');

      var textEl = document.createElement('span');
      textEl.className = 'gift-special-title-text';

      titleTextEl.appendChild(indicatorEl);
      titleTextEl.appendChild(textEl);
    }

    var titleLabelEl = titleTextEl.querySelector('.gift-special-title-text');
    var titleText = getGiftSpecialBaseTitle(root);
    var nextTitleText = isGiftSpecialSelected(root)
      ? titleText
      :titleText;

    if (titleLabelEl && titleLabelEl.textContent !== nextTitleText) {
      titleLabelEl.textContent = nextTitleText;
    }

    var badge = titleEl.querySelector('.gift-special-free-badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'gift-special-free-badge';
      titleEl.appendChild(badge);
    }
    if (badge.textContent !== 'Tap to Select') {
      badge.textContent = 'Tap to Select';
    }

    var optionLabel = root.querySelector('.hulkapps_mswatch_option');
    if (optionLabel) {
      optionLabel.removeAttribute('tabindex');
    }
  }

  function updateGiftSelectionRowState(root) {
    if (!root) return;
    removeGiftSelectionRow(root);
    var detailEl = ensureGiftDetailContainer(root);
    var isChecked = isGiftSpecialSelected(root);
    root.classList.toggle('is-selected', isChecked);
    root.setAttribute('role', 'checkbox');
    root.setAttribute('tabindex', '0');
    root.setAttribute('aria-checked', isChecked ? 'true' : 'false');
    if (detailEl) {
      detailEl.style.display = isChecked ? 'block' : 'none';
      detailEl.setAttribute('aria-hidden', isChecked ? 'false' : 'true');
    }
    ensureGiftSpecialTitleBadge(root);
  }

  function scheduleGiftSelectionRowSync(root) {
    if (!root) return;
    if (root._giftRowSyncPending) return;
    root._giftRowSyncPending = true;
    requestAnimationFrame(function () {
      root._giftRowSyncPending = false;
      updateGiftSelectionRowState(root);
    });
  }

  function getSelectedOption(root) {
    if (!root) return null;
    var selected = root.querySelector('.hulkapps_option_child.swatch_selected');
    if (!selected) {
      var checked = root.querySelector('.swatch_radio:checked');
      selected = checked ? checked.closest('.hulkapps_option_child') : null;
    }
    return selected;
  }

  function toggleGiftSpecialSelection(root) {
    if (!root || root._giftTogglePending) return;
    root._giftTogglePending = true;

    var inputBefore = getGiftSpecialCheckboxInput(root);
    var checkedBefore = !!(inputBefore && inputBefore.checked);
    var swatch = getGiftSpecialSwatch(root);
    if (swatch) {
      swatch.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }

    setTimeout(function () {
      var inputAfter = getGiftSpecialCheckboxInput(root);
      if (inputAfter && !!inputAfter.checked === checkedBefore) {
        inputAfter.click();
      }

      setTimeout(function () {
        root._giftTogglePending = false;
        updateGiftSelectionRowState(root);
      }, 80);
    }, 0);
  }

  function updateGiftSpecialDetail(root) {
    if (!root) return;
    var detailEl = ensureGiftDetailContainer(root);
    if (!detailEl) return;

    var detailHtml = [
      '<div class="gift-special-detail-title">Cleaning and Maintenance Kit</div>',
      '<ol class="gift-special-detail-steps">',
      '<li>Please tick this option if you would like to receive the Free Cleaning Kit with your order.</li>',
      '<li>Maintain your sex doll in optimal hygienic condition with the Cleaning and Maintenance Kit. All products in this kit are safe for both TPE and Silicone sex dolls.</li>',
      '</ol>',
      '<div class="gift-special-detail-subtitle">The Cleaning and Maintenance Kit includes:</div>',
      '<ul class="gift-special-detail-list">',
      '<li><strong>Sex Doll Cleaning Kit:</strong> Designed by Coeros, this kit simplifies the process of cleaning the vaginal area of sex dolls.</li>',
      '<li><strong>Absorbent Quick-Drying Stick:</strong> Ensure complete dryness in your sex doll&apos;s vaginal, anal, and oral cavities.</li>',
      '<li><strong>Microfiber Drying Towel:</strong> Wrap your sex doll in luxurious softness, making them feel pampered and plush.</li>',
      '<li><strong>Sex Doll Dryer:</strong> Designed by Coeros, the dryer helps dry a sex doll&apos;s vagina more thoroughly.</li>',
      '</ul>'
    ].join('');
    if (detailHtml) {
      if (detailEl.innerHTML !== detailHtml) {
        detailEl.innerHTML = detailHtml;
      }
      updateGiftSelectionRowState(root);
    } else {
      if (detailEl.innerHTML) detailEl.innerHTML = '';
      updateGiftSelectionRowState(root);
    }
  }

  function ensureGiftSpecialCheckboxVisible(root) {
    if (!root) return;
    var scope = root.matches && root.matches('.gift-special') ? root : root.querySelector('.gift-special');
    if (!scope) return;
    var inputs = scope.querySelectorAll('.hulk_po_checkbox input.hulk_po_swatch_multiple_checkbox');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (!input || !input.style) continue;
      if (input.closest && input.closest('.gift-special') !== scope) continue;
      if (input.dataset.giftNativeHidden === '1') continue;
      input.style.setProperty('position', 'absolute', 'important');
      input.style.setProperty('width', '1px', 'important');
      input.style.setProperty('height', '1px', 'important');
      input.style.setProperty('margin', '0', 'important');
      input.style.setProperty('padding', '0', 'important');
      input.style.setProperty('opacity', '0', 'important');
      input.style.setProperty('pointer-events', 'none', 'important');
      input.style.setProperty('clip', 'rect(0 0 0 0)', 'important');
      input.style.setProperty('clip-path', 'inset(50%)', 'important');
      input.style.setProperty('overflow', 'hidden', 'important');
      input.style.setProperty('white-space', 'nowrap', 'important');
      input.dataset.giftNativeHidden = '1';
    }
  }

  function bindGiftSpecialStateWatchers(root) {
    if (!root || root._giftStateWatchersBound) return;
    root._giftStateWatchersBound = true;

    var swatch = getGiftSpecialSwatch(root);
    var input = getGiftSpecialCheckboxInput(root);
    var sync = function () {
      updateGiftSelectionRowState(root);
    };

    if (swatch && !swatch._giftStateObserver) {
      swatch._giftStateObserver = new MutationObserver(sync);
      swatch._giftStateObserver.observe(swatch, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-checked']
      });
    }

    if (input) {
      if (!input._giftStateBound) {
        input._giftStateBound = true;
        input.addEventListener('change', sync);
        input.addEventListener('click', sync);
      }
      if (!input._giftStateObserver) {
        input._giftStateObserver = new MutationObserver(sync);
        input._giftStateObserver.observe(input, {
          attributes: true,
          attributeFilter: ['checked', 'class', 'style', 'aria-checked']
        });
      }
    }
  }

  function bindGiftSpecialSelection(root) {
    if (!root || root._giftSelectionBound) return;
    root._giftSelectionBound = true;
    root.setAttribute('role', 'checkbox');
    root.setAttribute('tabindex', '0');

    root.addEventListener('click', function (event) {
      if (root._giftTogglePending) return;
      var target = event.target;
      if (target && target.closest && target.closest('a, button, input, select, textarea')) return;
      event.preventDefault();
      toggleGiftSpecialSelection(root);
    });

    root.addEventListener('keydown', function (event) {
      if (!event) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggleGiftSpecialSelection(root);
    });

    root.addEventListener('change', function () {
      setTimeout(function () {
        ensureGiftSpecialCheckboxVisible(root);
        bindGiftSpecialStateWatchers(root);
        updateGiftSpecialDetail(root);
        scheduleGiftSelectionRowSync(root);
        setTimeout(function () {
          updateGiftSelectionRowState(root);
        }, 120);
      }, 0);
    });
  }

  function initGiftSpecialTitle(root) {
    if (!root || root._giftSpecialTitleObserver) return;
    var pending = false;
    function scheduleRefresh() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var options = root.querySelectorAll('.hulkapps_option_child');
        for (var i = 0; i < options.length; i++) {
          ensureGiftTitle(options[i]);
        }
        ensureGiftSpecialCheckboxVisible(root);
        bindGiftSpecialStateWatchers(root);
        updateGiftSpecialDetail(root);
        updateGiftSelectionRowState(root);
        ensureGiftSpecialTitleBadge(root);
      });
    }

    root._giftSpecialTitleObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (!target || target === root) {
          scheduleRefresh();
          return;
        }
        if (target.closest && target.closest('.gift-special-selected-detail')) {
          continue;
        }
        if (target.closest && target.closest('.gift-special-card-header')) {
          continue;
        }
        if (target.classList && (
          target.classList.contains('gift-special-swatch-title') ||
          target.classList.contains('gift-special-title-text') ||
          target.classList.contains('gift-special-selection-indicator')
        )) {
          continue;
        }
        scheduleRefresh();
        return;
      }
    });

    var initialOptions = root.querySelectorAll('.hulkapps_option_child');
    for (var j = 0; j < initialOptions.length; j++) {
      ensureGiftTitle(initialOptions[j]);
    }

    bindGiftSpecialSelection(root);
    ensureGiftSpecialCheckboxVisible(root);
    bindGiftSpecialStateWatchers(root);
    updateGiftSpecialDetail(root);
    updateGiftSelectionRowState(root);
    ensureGiftSpecialTitleBadge(root);
    root._giftSpecialTitleObserver.observe(root, {
      childList: true,
      subtree: true
    });
  }

    function setGiftSpecialElement(el) {
      if (!el || window.giftSpecialElement) return;
      window.giftSpecialElement = el;
    initGiftSpecialTitle(el);
      document.dispatchEvent(new CustomEvent('gift-special:ready', { detail: { element: el } }));
    }
  
    function initGiftSpecialWatcher() {
      if (!isProductPage()) return;
  
      var existing = findGiftSpecialElement();
      if (existing) {
        setGiftSpecialElement(existing);
        return;
      }
  
      var observer = new MutationObserver(function () {
        var el = findGiftSpecialElement();
        if (el) {
          setGiftSpecialElement(el);
          observer.disconnect();
        }
      });
  
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  
    onDomReady(initGiftSpecialWatcher);
  })();
  
  
  
